// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"244":"53d27308","564":"0fa49346","752":"7330d0df","888":"db85fdb2"}[chunkId] + ".js";
};